import { Inject, Injectable } from '@angular/core';
import { DATE_OPTIONS, DateOptions } from '@fgb/core';
import { NgbDateParserFormatter, NgbDateStruct } from '@ng-bootstrap/ng-bootstrap';
import moment from 'moment/moment';

/**
 * Formats the date to not include the year
 */
@Injectable({
  providedIn: 'root',
})
export class DateSelectNoYearFormatter extends NgbDateParserFormatter {
  dateFormat: string = 'MMM DD';

  constructor(@Inject(DATE_OPTIONS) readonly dateOption: DateOptions) {
    super();
  }

  parse(value: string): NgbDateStruct | null {
    if (!value) {
      return null;
    }

    let date = moment(value, this.dateFormat);

    if (date.isValid()) {
      return { year: date.year(), month: date.month() + 1, day: date.date() };
    }

    return null;
  }

  format(date: NgbDateStruct): string {
    if (!date) return '';
    let mdt = moment([date.year, date.month - 1, date.day]);
    if (!mdt.isValid()) return '';
    return mdt.format(this.dateFormat);
  }
}
